import { render, staticRenderFns } from "./ActionPremiumRating.vue?vue&type=template&id=e9dce3d8&scoped=true&"
import script from "./ActionPremiumRating.vue?vue&type=script&lang=js&"
export * from "./ActionPremiumRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9dce3d8",
  null
  
)

export default component.exports